import { render, staticRenderFns } from "./ProzessDragHandle.vue?vue&type=template&id=b99363f4"
import script from "./ProzessDragHandle.vue?vue&type=script&lang=js"
export * from "./ProzessDragHandle.vue?vue&type=script&lang=js"
import style0 from "./ProzessDragHandle.vue?vue&type=style&index=0&id=b99363f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports